<template>
  <div>
    <site-form :contractRequirementTypes="contractRequirementTypes" />
  </div>
</template>

<script>
import SiteForm from "../../components/sites/site-form";
import sitesApi from "../../api/sites";

export default {
  data() {
    return {
      contractRequirementTypes: []
    };
  },

  components: {
    "site-form": SiteForm
  },

  created() {
    var that = this;
    sitesApi
      .getSiteContractRequirementTypes()
      .then(function(response) {
        that.contractRequirementTypes = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};
</script>

<style scoped>
</style>
